export default {
  hint: 'Vahvista maksu pankkisi kanssa viimeistelläksesi tilauksesi.',
  cancel: 'Peruuta maksu',
};
